var FIGURE = FIGURE || {};

// Wine detail page: "View More +" reveals the technical spec rows the template rendered
// hidden. The collapsed state ships from the server rather than being applied here, so
// the list never flashes open before this runs.
FIGURE.wineSpecs = function() {
    document.querySelectorAll('[data-wine-specs-toggle]').forEach(function(toggle) {
        var list = document.getElementById(toggle.getAttribute('aria-controls'));
        if (!list) return;

        var label = toggle.querySelector('[data-wine-specs-label]');
        var sign = toggle.querySelector('[data-wine-specs-sign]');

        toggle.addEventListener('click', function() {
            var expanded = toggle.getAttribute('aria-expanded') === 'true';

            list.querySelectorAll('[data-wine-spec-extra]').forEach(function(row) {
                row.hidden = expanded;
            });

            toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
            if (label) label.textContent = expanded ? 'View More' : 'View Less';
            if (sign) sign.textContent = expanded ? '+' : '−';
        });
    });
}();
